<template>
  <v-app v-if="loading">
    <v-main>
      <v-container fill-height>
        <v-row align="center" justify="center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import config from '@/config';

export default {
  name: 'ProlificMainStudy',
  data() {
    return {
      sessionId: this.$route.params.sessionId,
      graphId: this.$route.params.graphId || null,
      loading: true,
    };
  },
  async created() {
    try {
      const sessionResp = await fetch(`${config.API_BASE_URL}/prolific/session/${this.sessionId}/`);
      const session = await sessionResp.json();

      if (session.phase === 'completed') {
        this.$router.replace(`/prolific/study/${this.sessionId}/finish`);
        return;
      }
      if (session.phase === 'screened_out') {
        this.$router.replace(`/prolific/study/${this.sessionId}/training-failed`);
        return;
      }
      if (session.main_study_complete) {
        this.$router.replace(`/prolific/study/${this.sessionId}/post-study`);
        return;
      }

      let graphId = this.graphId;
      if (!graphId) {
        const nextResp = await fetch(
          `${config.API_BASE_URL}/prolific/session/${this.sessionId}/main/next_graph/`
        );
        const nextData = await nextResp.json();
        if (nextData.study_complete) {
          this.$router.replace(`/prolific/study/${this.sessionId}/post-study`);
          return;
        }
        graphId = nextData.graph_id;
      }

      this.$router.replace({
        path: `/prolific/study/${this.sessionId}/label/${graphId}`,
        query: this.$route.query,
      });
    } catch (e) {
      console.error(e);
    }
  },
};
</script>
